import apiFetch from "@/app/auth/apiFetch";
import type { NavigateFunction } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL;

export interface DataStatsResponse {
  total: number;
  complete?: number;
  in_progress?: number;
  total_links?: number;
  complete_links?: number;
  top?: { name: string; count: number }[];
  top_metric?: string; // "candidates" | "followers"
}

/** Stats d'une entité "Données" pour les graphiques admin (backoffice /admin/data-stats). */
export async function getDataStats(navigate: NavigateFunction, entity: string): Promise<DataStatsResponse> {
  const res = await apiFetch(
    `${API_URL}/admin/data-stats?entity=${encodeURIComponent(entity)}`,
    { method: "GET" },
    navigate
  );
  if (!res?.ok) throw new Error("Erreur lors du chargement des statistiques");
  return res.json();
}
